module.exports = __webpack_public_path__ + "img/call__kws.e8455609.svg";